import DropdownNavigationView from './DropdownNavigationView';

export default DropdownNavigationView;
